// Text supplied by the user. Preserve this wording rather than substituting
// a different published translation; stanza spacing is for readability only.
export const GUADALUPE_JOHN_PAUL_PRAYER = {
  id: "guadalupe-jpii",
  title: "Prayer to Our Lady of Guadalupe",
  author: "St. John Paul II the Great",
  sourceLabel: "Crossroads Initiative · John Paul II’s Prayer to Our Lady of Guadalupe",
  sourceUrl: "https://www.crossroadsinitiative.com/media/articles/john-paul-iis-prayer-to-our-lady-of-guadalupe/",
  text: `O Immaculate Virgin,
Mother of the True God
and Mother of the Church!
You, who from this place reveal your clemency and your pity
to all those who ask for your protection;
hear the prayer that we address to you with filial trust,
and present it to your Son Jesus, our sole Redeemer.

Mother of mercy,
Teacher of hidden and silent sacrifice,
to you, who come to meet us sinners,
we dedicate on this day all our being and all our love.
We also dedicate to you our life, our work,
our joys, our infirmities and our sorrows.
Grant peace, justice, and prosperity to our people;
for we entrust to your care
all that we have and all that we are,
Our Lady and Mother.
We wish to be entirely yours
and to walk with you
along the way of complete faithfulness to Jesus Christ in His Church:
hold us always with your loving hand.

Virgin of Guadalupe,
Mother of the Americas,
we pray to you for all the bishops,
that they may lead the faithful
along paths of intense Christian life,
of love and humble service of God and souls.
Contemplate this immense harvest, and intercede with the Lord
that he may instill a hunger for holiness
in the whole People of God,
and grant abundant vocations of priests and religious,
strong in the faith and zealous dispensers of God’s mysteries.

Grant to our homes
the grace of loving and respecting life in its beginnings,
with the same love with which you conceived in your womb the life of the Son of God.
Blessed Virgin Mary,
Mother of Fair Love,
protect our families,
so that they may always be united,
and bless the upbringing of our children.

Our hope, look upon us with compassion,
teach us to go continually to Jesus
and, if we fall,
help us to rise again,
to return to him, by means of the confession of our faults and sins
in the Sacrament of Penance,
which gives peace to the soul.

We beg you to grant us
a great love for all the holy Sacraments,
which are, as it were,
the signs that your Son left us on earth.

Thus, most holy Mother,
with the peace of God in our conscience,
with our hearts free from evil and hatred,
we will be able to bring to all
true joy and true peace,
which come to us from your Son,
our Lord Jesus Christ,
who with God the Father and the Holy Spirit,
lives and reigns for ever and ever.
Amen.`,
};